import { ref } from "vue";

export type AppTheme = "day" | "night";

const STORAGE_KEY = "theme";
const theme = ref<AppTheme>("day");

function apply(value: AppTheme) {
    theme.value = value;
    document.documentElement.setAttribute("data-theme", value);
    document.body.setAttribute("data-theme", value);
    localStorage.setItem(STORAGE_KEY, value);
}

export function initTheme() {
    const stored = localStorage.getItem(STORAGE_KEY) as AppTheme | null;
    apply(stored === "day" ? "day" : "night");
}

export function useTheme() {
    function setTheme(value: AppTheme) {
        apply(value);
    }

    function toggleTheme() {
        apply(theme.value === "day" ? "night" : "day");
    }

    return { theme, setTheme, toggleTheme };
}
